import { useEffect, useRef, useState } from "react";

/*
 * Lightweight count-up for KPI numbers. Zero dependencies, respects
 * prefers-reduced-motion (jumps straight to the final value).
 */
export default function useCountUp(target, duration = 900) {
    const numericTarget = Number.isFinite(Number(target)) ? Number(target) : 0;
    const [value, setValue] = useState(0);
    const frame = useRef(null);

    useEffect(() => {
        const reduced =
            window.matchMedia &&
            window.matchMedia("(prefers-reduced-motion: reduce)").matches;

        if (reduced || numericTarget === 0) {
            setValue(numericTarget);
            return undefined;
        }

        const start = performance.now();
        const tick = now => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3); // ease-out-cubic
            setValue(Math.round(numericTarget * eased));
            if (p < 1) frame.current = requestAnimationFrame(tick);
        };

        frame.current = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(frame.current);
    }, [numericTarget, duration]);

    return value;
}
